import React from "react";
import { Link } from "react-router-dom";

import { FormHandler } from "Components/Form";
import { RegistrationForm } from "Components/Partials";
import Authenticated from "Components/Layouts/Authenticated";

import MeApi from 'Services/Api/Me/Me';
import { DateTime } from "luxon";
import { Container } from "Components/Utilities";
import { PrimaryButton } from "Components/Button";
import { asset } from "Services/BaseHelpers";
import { User } from "Services";

class Registration extends React.Component {
    state = {
        stage: null,
        group: null
    };

    handleSuccess = (attending, group) => {
        this.setState({
            stage: attending ? 'confirm-attending' : 'confirm-not-attending',
            group: group
        });
    };

    handleSubmit = (data) => MeApi.registration(data);

    render () {
        const { stage, group } = this.state;

        const isPastDeadline = DateTime.now() > DateTime.fromISO('2026-10-03T00:01:00');

    // if (stage === 'registration-closed' || isPastDeadline) {
    //     return (
    //         <Authenticated pageVideoHeader={ true }>
    //             <div className="py-10 lg:py-20">
    //                 <Container>
    //                     <div className="text-center text-app-blue space-y-6">
    //                         <h2 className="text-5xl font-bold mb-4">Registration Closed</h2>
    //                         <p>Registration for the Bupa Symposium has closed.</p>
    //                         <p>
    //                             If you have any questions, please contact us at <a href="mailto:reply@bupahealthcaresymposium.com" className="underline">healthcaresymposium@bupa.com</a>
    //                         </p>
    //                     </div>
    //                 </Container>
    //             </div>
    //         </Authenticated>
    //     );
    // }

        if (stage === 'confirm-attending' && !this.props.isAdmin) {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="">
                        <div className="space-y-6 text-xl text-white bg-app-blue text-center py-10 lg:py-20">
                            <div className="text-4xl font-bold max-w-4xl mx-auto">
                                Thank you for registering to attend the Bupa Symposium 2025
                            </div>
                        </div>
                        <div className="space-y-6 text-xl text-white bg-app-light-blue text-center py-5 lg:py-10">
                            <div className="text-2xl font-bold max-w-4xl mx-auto">
                                📅 Wednesday 15 October 2025 | 📍 London
                            </div>
                        </div>
                            <Container>
                                <div className="space-y-10 text-xl text-app-blue text-center mt-6">
                                    <p className="max-w-4xl mx-auto text-bold">
                                        Look out for more updates from us soon.
                                    </p>

                                     <p className="max-w-4xl mx-auto">
                                        In the meantime, if you have any questions or need to update your details, just email us at  <a
                                         href="mailto:healthcaresymposium@bupa.com"
                                         className="underline"
                                     >healthcaresymposium@bupa.com</a>
                                    </p>
                                    <div>
                                        { group?.includes ( 'virtual' ) ? (
                                            <a
                                                href={ asset ( 'images/bupa-virtual.ics' ) }
                                                target="_blank"
                                            >
                                                <PrimaryButton text="Add to Calendar" />
                                            </a>
                                        ) : (
                                            <a
                                                href={ asset ( 'images/bupa-25.ics' ) }
                                                target="_blank"
                                            >
                                                <PrimaryButton text="Add to Calendar" />
                                            </a>
                                        ) }
                                    </div>
                                    <p>
                                        We look forward to seeing you there!<br />
                                        Bupa Events Team
                                    </p>
                                </div>
                            </Container>
                    </div>
                </Authenticated>
            );
        } else if (stage === 'confirm-attending' && this.props.isAdmin) {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="">
                        <div className="space-y-6 text-xl text-white bg-app-blue text-center py-10 lg:py-20">
                            <div className="text-4xl font-bold max-w-4xl mx-auto">
                                Thank you for registering to attend the Bupa Symposium 2025
                            </div>
                        </div>
                        <div className="space-y-6 text-xl text-white bg-app-light-blue text-center py-5 lg:py-10">
                            <div className="text-2xl font-bold max-w-4xl mx-auto">
                                📅 Wednesday 15 October 2025 | 📍 London
                            </div>
                        </div>
                            <Container>
                                <div className="space-y-10 text-xl text-app-blue text-center mt-6">
                                    <p className="max-w-4xl mx-auto text-bold">
                                        Look out for more updates from us soon.
                                    </p>

                                     <p className="max-w-4xl mx-auto">
                                        In the meantime, if you have any questions or need to update your details, just email us at  <a
                                         href="mailto:healthcaresymposium@bupa.com"
                                         className="underline"
                                     >healthcaresymposium@bupa.com</a>
                                    </p>
                                    <div>
                                        { group?.includes ( 'virtual' ) ? (
                                            <a
                                                href={ asset ( 'images/bupa-virtual.ics' ) }
                                                target="_blank"
                                            >
                                                <PrimaryButton text="Add to Calendar" />
                                            </a>
                                        ) : (
                                            <a
                                                href={ asset ( 'images/bupa-25.ics' ) }
                                                target="_blank"
                                            >
                                                <PrimaryButton text="Add to Calendar" />
                                            </a>
                                        ) }
                                    </div>
                                    <p>
                                        We look forward to seeing you there!<br />
                                        Bupa Events Team
                                    </p>
                                </div>
                            </Container>
                    </div>
                </Authenticated>
            );
        }

        if ( stage === 'confirm-not-attending' ) {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="">
                        <div className="space-y-6 text-xl text-white bg-app-blue text-center py-10 lg:py-20">
                            <div className="text-4xl font-bold max-w-4xl mx-auto">
                                Thank you for confirming that you will be attending the Bupa Symposium 2025 virtually. You will shortly receive a confirmation email.
                            </div>
                        </div>
                        <div className="space-y-6 text-xl text-white bg-app-light-blue text-center py-5 lg:py-10">
                            <div className="text-2xl font-bold max-w-4xl mx-auto">
                                📅 Wednesday 15 October 2025 | 📍 London
                            </div>
                        </div>
                            <Container>
                                <div className="space-y-10 text-xl text-app-blue text-center mt-6">
                                    <p className="max-w-4xl mx-auto text-bold">
                                        Look out for more updates from us soon.
                                    </p>

                                     <p className="max-w-4xl mx-auto">
                                        In the meantime, if you have any questions or need to update your details, just email us at  <a
                                         href="mailto:healthcaresymposium@bupa.com"
                                         className="underline"
                                     >healthcaresymposium@bupa.com</a>
                                    </p>
                                    <div>
                                        { group?.includes ( 'virtual' ) ? (
                                            <a
                                                href={ asset ( 'images/bupa-virtual.ics' ) }
                                                target="_blank"
                                            >
                                                <PrimaryButton text="Add to Calendar" />
                                            </a>
                                        ) : (
                                            <a
                                                href={ asset ( 'images/bupa-25.ics' ) }
                                                target="_blank"
                                            >
                                                <PrimaryButton text="Add to Calendar" />
                                            </a>
                                        ) }
                                    </div>
                                    <p>
                                        We look forward to seeing you there!<br />
                                        Bupa Events Team
                                    </p>
                                </div>
                            </Container>
                    </div>
                </Authenticated>
            );
        }

        if(this.props.isAdmin) {
            return (
                <RegistrationForm
                    onSubmit={ this.handleSubmit }
                    onSuccess={ this.handleSuccess }
                    isAdmin={ true }
                    { ...this.props }
                />
            );
        }

        return (
            <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                <RegistrationForm
                    onSubmit={ this.handleSubmit }
                    onSuccess={ this.handleSuccess }
                    { ...this.props }
                    isAdmin={ false }
                    disableInPerson={isPastDeadline}
                    isPastDeadline={isPastDeadline}
                />
            </Authenticated>
        );
    }
}

export default FormHandler ( Registration );
